<template>
  <div
    testek="button"
    class="flex items-center btn-default"
    :class="[
      classButton,
      classHover,
      classActive,
      type,
      disabled ? 'disabled-btn' : '',
      `btn-${type}`,
      border ? '' : 'border-none',
    ]"
    :style="{
      minHeight: height + 'px',
      minWidth: width + 'px',
    }"
  >
    <div class="icon-left" :class="icon" v-if="icon && postion == 'left'"></div>
    <button
      @click="onEvent('click')"
      @blur="onEvent('blur')"
      @mousedown="onEvent('mousedown')"
      @mouseover="onEvent('mouseover')"
      @mouseleave="onEvent('mouseleave')"
      :style="{
        minHeight: height + 'px',
        minWidth: width + 'px',
      }"
      :disabled="disabled"
      class="w-100"
      v-bind="$attrs"
    >
      {{ title }}
    </button>
    <div
      class="icon-right"
      :class="icon"
      v-if="icon && postion == 'right'"
    ></div>
  </div>
</template>
<script>
export default {
  name: "HButton",
  props: {
    type: {
      default: "ghost", // Các loại type : primary | ghost | dashed | link | text | default
      typeof: String,
    },
    title: {
      default: "",
      typeof: String,
    },
    disabled: {
      default: false,
      typeof: Boolean,
    },
    icon: {
      default: false,
      typeof: String,
    },
    classButton: {
      default: "",
      typeof: String,
    },
    classActive: {
      default: "",
      typeof: String,
    },
    classHover: {
      default: "",
      typeof: String,
    },
    type: {
      default: "",
      typeof: String,
    },
    height: {
      default: 36,
      typeof: Number,
    },
    width: {
      default: 100,
      typeof: Number,
    },
    postion: {
      default: "left",
      typeof: String,
    },
    icon: {
      default: "",
      typeof: String,
    },
    border: {
      default: true,
      typeof: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {
    onEvent(event) {
      switch (event) {
        case "click":
          this.$emit("click");
          break;
        case "blur":
          this.$emit("blur");
          break;
        case "mousedown":
          this.$emit("mousedown");
          break;
        case "mouseover":
          this.$emit("mouseover");
          break;
        case "mouseleave":
          this.$emit("mouseleave");
          break;
      }
    },
  },
};
</script> 
<style lang="scss" scoped>
.btn-default {
  height: 32px;
  padding: 5px 16px;
  min-width: 100px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  background: #fff;
  cursor: pointer;
  color: #212121;

  &:hover {
    background: #e6e6e6;
  }

  &:active {
    background: #e6e6e6;
  }
  // :hover {
  //   color: #4096ff;
  //   border-color: #4096ff;
  // }

  // :active {
  //   color: #0958d9;
  //   border-color: #0958d9;
  // }
}

.btn-primary {
  display: flex;
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  color: white;
  background: #1677ff;
  &:hover {
    color: #fff !important;
    background-color: #4096ff !important;
  }

  &:active {
    color: #fff !important;
    background-color: #0958d9 !important;
  }
}
.btn-black {
  background: #212121;
  &:hover {
    color: #fff !important;
    background-color: #464545 !important;
  }

  &:active {
    color: #fff !important;
    background-color: #464545 !important;
  }
}

.border-none {
  border: none;
}

.primary {
  background: #fff;
  color: #fff;
  border: 1px solid #665e5e;
}
.primary:hover {
  border: 1px solid #665e5e;
}
.secondary {
  background: #0f172a !important;
  color: #fff;
}
.secondary:hover {
  background: #334155 !important;
}
</style>